export default __webpack_public_path__ + "static/media/inprogress.a4372818.svg";